import toast from "react-hot-toast";


export default function ResponseErrorHandel(error) {




    const status = error?.response?.data?.data?.status || error?.response?.data?.status;
    const message = error?.response?.data?.data?.en_message || error?.response?.data?.en_message;

    if (error.message.includes("timeout")) {
        toast.error("Request timeout exceeded. Please try again later.");
        return;
    }


    if (!error?.response) {
        toast.error("Check your internet connection and try again later.");
        return;
    }


    switch (status) {
        case 403:
        case 401:
            localStorage.clear();
            window.location.reload();
            break;
        case 400:
        case 402:
        case 404:
        case 409:
            console.log("hi")
            toast.error(message);
            break;
        default:
            if (status >= 500) {
                toast.error("Internal Server Error");
            }
            break;
    }

}

